<template>
  <div class="videoWrapper rounded" oncontextmenu="return false;">
    
    <youtube-iframe class="rounded" :video-id="movieClip.youtube_id" :width="get_width"
        :height="get_height" :player-vars="params" :cookie="true" @stateChange="state_changed" referrerpolicy="no-referrer-when-downgrade" @error="handle_error"></youtube-iframe>
  </div>
</template>

<script>

document.oncontextmenu = function() { 
    return false; 
};
import { YoutubeIframe } from '@vue-youtube/component';
export default {

  components:{YoutubeIframe},

  computed:{
    isMobile() {
       if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
       } else {
         return false
       }
    },
    get_width() {
      if(this.$vuetify.display.smAndDown){
        return this.$vuetify.display.width-50;
      }else{
        return 560;
      }
    },

    get_height() {
      if(this.$vuetify.display.smAndDown){
        return (this.$vuetify.display.width)/1.778;
      }else{
        return 315;
      }
    },

  },

  methods:{
    state_changed(event){
      if(event.target.getPlayerState() == 2){
        event.target.playVideo();
      }
    },

    handle_error(){
      this.getClip();
    }
  },

  beforeMount(){
    clearInterval(this.interval);
  },

  beforeUnMount(){
    clearInterval(this.interval);
  },

  data() {
    return {
      params: {
        showinfo: 0,
        controls: 0,
        loop: 1,
        autoplay: 1,
        playsinline: 1,
        playlist: this.movieClip.youtube_id,
        end: 50,
        start: 0,
        disablekb: 1,
        fs: 0,
        cc_load_policy:3,
        iv_load_policy:3
      },

      interval: ""
    };




  },


  props: {
    movieClip: Object,
    getClip: Function
  },
};
</script>
<style>
.videoWrapper {

  overflow: hidden;
}

iframe {
  margin-top: -60px;
}

</style>
